import { match } from 'ts-pattern';
import { z } from 'zod';

import type { ContractDealListQuery } from '../-query/type';

export const ContractDealSearchSchema = z.object({
  pageIndex: z.number().default(0),
  pageSize: z.number().default(100),
  freeText: z.string().optional(),
  showTerminated: z.boolean().default(true),
  contractStartFrom: z.string().optional(),
  contractStartTo: z.string().optional(),
  contractEndFrom: z.string().optional(),
  contractEndTo: z.string().optional(),
  sortColumn: z.string().optional(),
  sortOrder: z.enum(['asc', 'desc']).optional(),
});

export type ContractDealSearch = z.infer<typeof ContractDealSearchSchema>;

type ContractDealOrderBy = NonNullable<ContractDealListQuery['orderBy']>;

export function toContractDealOrderBy(
  sortColumn: string | undefined,
  options?: { includeSoftware?: boolean },
): ContractDealOrderBy | undefined {
  if (!sortColumn) return undefined;
  return match(sortColumn)
    .with(
      'software',
      () =>
        (options?.includeSoftware ? 'softwareName' : undefined) as
          | ContractDealOrderBy
          | undefined,
    )
    .with('title', () => 'contractTitle' as ContractDealOrderBy)
    .with('status', () => 'contractStatus' as ContractDealOrderBy)
    .with('contractPeriod', () => 'contractPeriod' as ContractDealOrderBy)
    .with('responsiblePerson', () => 'responsiblePerson' as ContractDealOrderBy)
    .otherwise(() => undefined);
}
